// ============================================================
// Fees Layout
// ============================================================
// Wraps all routes in the fees module and provides sub-navigation.

import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

export function FeesLayout() {
  return (
    <Box sx={{ width: '100%' }}>
      <Outlet />
    </Box>
  );
}
